import { Spinner } from "reactstrap";
import logo from "@src/assets/images/rezo/logo-lg.png";

const SpinnerComponent = () => {
  return (
    <div className="fallback-spinner vh-100">
      <img className="fallback-logo" src={logo} alt="logo" />
      <div className="loading">
        <Spinner color="primary" className="mt-2" />

        {/* <div className="effect-1 effects"></div>
        <div className="effect-2 effects"></div>
        <div className="effect-3 effects"></div> */}
      </div>
    </div>
  );
};

export default SpinnerComponent;
